
import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import { ModalHeader, ModalContent, ModalFooter, ContentItem, Dropdown } from '@gnb/components/Common'
import PreferenceContentTemplate from '@gnb/templates/PreferenceContentTemplate.vue'
import CheckSlider from '@gnb/components/Common/CheckSlider.vue'

@Component({
    components: {
        ModalHeader,
        ModalContent,
        ModalFooter,
        ContentItem,
        PreferenceContentTemplate,
        Dropdown,
        CheckSlider
    }
})
export default class RuleView extends Vue {
    @Prop({ type: Array }) rules!: gnb.rules.Rule[];

    //
    // ────────────────────────────────────────────────────── I ──────────
    //   :::::: M E T H O D S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────
    //

    onAddClick() {
        this.$emit('add');
    }

    onMoveClick(from: gnb.rules.Rule, to: gnb.rules.Rule) {
        this.$emit('swap', from, to);
    }

    onEditClick(rule: gnb.rules.Rule) {
        this.$emit('edit', rule)
    }

    async onDeleteClick(rule: gnb.rules.Rule) {     
        if(await (window as any).confirmAsync(this.$t('삭제_하시겠습니까').toString())) {
            this.$emit('delete', rule);
        }         
    }
   
    onEnableChange(rule: gnb.rules.Rule) {
        this.$emit('change', rule);
    }
}
